export default __webpack_public_path__ + "static/media/my-pic.501522e9.jpg";